<template>
<div class="ActivityIncomeList">
    <div class="bgc box-shadow title">
        <div class="classes blod">{{title}}</div>
    </div>
    <div class="data-total">
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">收款总额</div>
                    <div class="box-data"><span class="data">{{item.totalincome}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="全部活动的成交订单收款总额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">成交总数量</div>
                    <div class="box-data"><span class="data">{{item.ordercount}}</span></div>
                </div>
            </div>

            <el-tooltip content="全部活动的成交数量" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">总手续费</div>
                    <div class="box-data"><span class="data">{{item.totalpoundage}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="全部活动的成交订单所产生的手续费" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">返现总额</div>
                    <div class="box-data"><span class="data">{{item.totalbrokerage}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="全部活动的分销返现金额合计" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">实收总额</div>
                    <div class="box-data"><span class="data">{{item.factincome}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="全部活动商家实际应收金额， 等于成交总金额-返现总金额-支付手续费" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
    </div>
    <div class="filters bgc">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A09')==-1" type="success" @click="handleExport">导出Excel</el-button>
        </div>
        <div class="search">
            <!--<el-select v-model="param.status" placeholder="请选择" @change="handleQuery">-->
                <!--<el-option v-for="item in statusList" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>-->
            <!--</el-select>-->
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="title" label="活动名称" min-width="296">
                <template slot-scope="scope">
                    <div class="titlebox">
                        <div class="text">{{scope.row.title}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="ordercount" label="成交数量" class-name="center"></el-table-column>
            <el-table-column prop="cashtypetext" label="成交金额" class-name="center">
                <template slot-scope="scope">￥{{scope.row.totalincome}}</template>
            </el-table-column>
            <el-table-column prop="cashmoney" label="返现金额" class-name="center">
                <template slot-scope="scope">￥{{scope.row.totalbrokerage}}</template>
            </el-table-column>
            <el-table-column prop="status" label="手续费" class-name="center">
                <template slot-scope="scope">￥{{scope.row.totalpoundage}}</template>
            </el-table-column>
            <el-table-column prop="authdesp" label="实收金额" class-name="right">
                <template slot-scope="scope">￥{{scope.row.factincome}}</template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getEventListByFinance, exportEventListByFinance} from 'api/nationalDistribution'
import {nationalDistribution} from 'api/enumCode'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'ActivityIncomeList',
    data() {
        return {
            activityList: [],
            title: '活动收入',
            tableData: [],
            total: 0,
            statusList: nationalDistribution.status,
            loading: false,
            item: {
                ordercount: '', // 订单总数
                totalincome: '', // 订单收入总额
                totalpoundage: '', // 订单手续费
                totalbrokerage: '', // 返现总额
                factincome: '' // 实收总额
            },
            selectPage: {
                page: 1,
                pageSize: 10,
                pageCount: 1
            }
        }
    },
    props: ['param', 'flag'],
    mounted() {
        this.power = this.permission.btnObj.A09 ? this.permission.btnObj.A09 : []
        this._getList()
    },
    methods: {
        handleQuery() {
            this._getList()
        },
        handleExport() {
            this.setLoading(true)
            exportEventListByFinance({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '活动收入' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getEventListByFinance({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.item = data.data.summaryinfo
                    }
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            return value
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                for (let i = 0; i < nationalDistribution.status.length; i++) {
                    if (value === nationalDistribution.status[i].code) {
                        return nationalDistribution.status[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.ActivityIncomeList {
    .title{
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        .classes{
            margin-bottom: 0;
        }
    }
    .titlebox{
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        .text{
            float: right;
            /* "margin-left"要等于".wrap::before"的宽度 */
            margin-left: -10px;
            width: 100%;
            word-break: break-all;
            text-align: left;
            font-size: 14px;
            // font-size: 0.48rem;
        }
        &::before {
            float: left;
            content: '';
            width: 10px;
            height: 100%;
        }
        &::after {
            float: right;
            content: "...";
            height: 40px;
            line-height: 20px;
            width: 37px;
            margin-left: -37px;
            position: relative;
            left: 101.9%;
            bottom: 20px;
            font-weight: 600;
            padding-right: 1px;
            background: #fff;
            transition: all 0.5s;
            text-align: left;
        }
    }
    .data-total{
        margin-top: 24px;
        @include flexBox(space-between);
        .outbox{
            padding: 30px;
            height: 100px;
            box-sizing: border-box;
            position: relative;
            flex-grow: 1;
            flex-basis: 200px;
            .box{
                .box-title{
                    font-size: $font-14;
                }
                .box-data{
                    margin-top: 12px;
                    color: $tcolor-blue;
                    font-size: $font-16;
                    .data{
                        font-size: $font-30;
                    }
                }
            }
            .el-tooltip{
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
            }
        }
        .outbox+.outbox{
            margin-left: 40px;
        }
    }
    .filters{
        margin-top: 24px;
        margin-bottom: 0;
        padding: 20px 20px 10px 20px;
    }
    .center{
        .cell{
            text-align: center;
        }
    }
    .right{
        .cell{
            text-align: right;
        }
    }
}
</style>
